import { useAuth } from '../../hooks/useAuth'
import { requiredRole } from '../../configs'
import type { RoleGuardProps } from './RoleGuard.types'
import { useEffect, useState } from 'react'
import { jwtDecode } from 'jwt-decode'

export function RoleGuard({ children }: RoleGuardProps) {
  const { account, getToken } = useAuth()
  const [hasAccess, setHasAccess] = useState(false)

  useEffect(() => {
    checkHasAccess(getToken, setHasAccess).catch(() => setHasAccess(false))
  }, [account, getToken])

  if (!hasAccess) {
    return (
      <>
        <div>
          Sorry, your account does not have access to this. Speak to your
          Engineering Manager if you think this is a mistake.
        </div>
      </>
    )
  }

  return <>{children}</>
}

const checkHasAccess = async (
  getToken: () => Promise<string>,
  setHasAccess: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const token = await getToken()
  if (!token) {
    setHasAccess(false)
    return
  }

  const decodedToken = jwtDecode<{ roles?: string[] }>(token)
  const hasAccessInner = decodedToken.roles?.includes(requiredRole) ?? false

  setHasAccess(hasAccessInner)
}
